import {
  isSupported,
  getMessaging,
  getToken as getMessagingToken,
  deleteToken as deleteMessagingToken
} from 'firebase/messaging'
import app from '@/modules/firebase'

const vapidKey = import.meta.env.VITE_VAPID_KEY as string

export async function isMessagingSupported() {
  return isSupported()
}

export async function getToken(registration: ServiceWorkerRegistration) {
  const messaging = getMessaging(app)
  return getMessagingToken(messaging, {
    vapidKey,
    serviceWorkerRegistration: registration
  })
}

export async function deleteToken() {
  const messaging = getMessaging(app)
  return deleteMessagingToken(messaging)
}

// TODO: Add in-app notification handling via `onMessage`
